import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appBlockCopyPaste]',
    standalone: false
})
export class BlockCopyPasteDirective {
	constructor() {}

	@HostListener('paste', ['$event']) blockPaste(e: ClipboardEvent) {
		e.preventDefault();
	}

	@HostListener('copy', ['$event']) blockCopy(e: ClipboardEvent) {
		e.preventDefault();
	}

	@HostListener('cut', ['$event']) blockCut(e: ClipboardEvent) {
		e.preventDefault();
	}
}
